import { normalizeStrokeWidth } from './utils/normalizeStrokeWidth.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { SVG } from '../utils/style.svg.js';

const PM2PuzzleIcon = ({
  color = "currentColor",
  strokeWidth = 1.5,
  ...svgProps
}) => {
  return /*#__PURE__*/jsxs(SVG, {
    xmlns: "http://www.w3.org/2000/svg",
    ...svgProps,
    viewBox: "0 0 24 22.393",
    fill: "none",
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: normalizeStrokeWidth(strokeWidth, 22.393),
    children: [/*#__PURE__*/jsx("path", {
      d: "m23.246 5.172v14.864a1.607 1.607 0 0 1 -1.6 1.607h-20.891"
    }), /*#__PURE__*/jsx("path", {
      d: "m23.228.75h-20.871a1.607 1.607 0 0 0 -1.607 1.607v14.893"
    }), /*#__PURE__*/jsx("path", {
      d: "m23.25 5.036h-8.036v1.607"
    }), /*#__PURE__*/jsx("path", {
      d: "m6.2 5.21h3.925v-3.925"
    }), /*#__PURE__*/jsx("path", {
      d: "m13.937 12.926v-3.925h-12.558"
    }), /*#__PURE__*/jsx("path", {
      d: "m14.312 17.252h3.925v-7.67"
    }), /*#__PURE__*/jsx("path", {
      d: "m6.2 13.417h3.925v7.67"
    }), /*#__PURE__*/jsx("path", {
      d: "m.843 17.252h3.925"
    })]
  });
};

export { PM2PuzzleIcon };
//# sourceMappingURL=puzzle.js.map
